<template>
  <div>
    <div class="card-body">
      <h3 class="h5 mb-2">{{ trans('dashboard.account.profile.delete_account.title') }}</h3>
      <p class="text-muted">{{ trans('dashboard.account.profile.delete_account.description') }}</p>
      <div class="form_row">
        <button type="button" class="button button_danger" @click.prevent="showModalForm">
          {{ trans('dashboard.account.profile.delete_account.button') }}
        </button>
      </div>
    </div>
    <modal :show="isShowModal" name="delete-account-modal" @close="handleClose">
      <template #title>
        <h2 class="text-90 font-normal text-xl">{{ trans('dashboard.account.profile.delete_account.title') }}</h2>
      </template>

      <template #content>
        <form @submit.prevent="submit" role="form">
          <p class="text-80 leading-normal mt-3">
            {{ trans('dashboard.account.profile.delete_account.confirmation.description') }}
          </p>

          <form-input id="confirm-delete-account"
                      type="checkbox"
                      v-model="form.confirm"
                      :label-text="trans('dashboard.account.profile.delete_account.confirmation.label')"
                      :error="form.errors.confirm"
                      container-class="form-group mt-4"/>
        </form>
      </template>
      <template #footer>
        <button type="button" @click.prevent="handleClose" class="button button_cancel">
          {{ trans('common.cancel') }}
        </button>
        <button id="confirm-delete-button" type="submit" class="button button_danger" @click.prevent="submit">
          {{ trans('dashboard.account.profile.delete_account.confirmation.button') }}
        </button>
      </template>
    </modal>
  </div>
</template>

<script setup>
import {ref} from "vue"
import {useForm} from "@inertiajs/vue3"
import Modal from "@/components/Shared/Modal"
import FormInput from "@/components/Shared/Form/Input/Index"

defineProps({
  user: Object
})

const isShowModal = ref(false)
const form = useForm({
  confirm: false
})

const handleClose = function () {
  isShowModal.value = false
}

const showModalForm = () => {
  isShowModal.value = true
}

const submit = () => form.post('/settings/user/delete')
</script>
